/**
 * Auth0 session detection via localStorage sniffing.
 *
 * What: Checks for the Auth0 SPA SDK's cache keys without importing the SDK.
 * Why: Both the full app entry and the lean marketing boot need to know
 * "does this browser have an Auth0 session?" before any auth code loads —
 * the lean boot uses it to skip straight to the app shell for signed-in
 * users, and analytics uses it to exclude our own traffic.
 * When: Update if the Auth0 SPA SDK changes its localStorage key scheme.
 */

export const AUTH0_SPA_KEY_PREFIX = '@@auth0spajs@@::';

export const hasAuth0SessionInStorage = (): boolean => {
  try {
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(AUTH0_SPA_KEY_PREFIX)) {
        return true;
      }
    }
  } catch {
    // localStorage can throw in private-mode Safari or sandboxed iframes;
    // treat as "not authenticated" so visitor tracking still runs.
  }
  return false;
};
